// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ion-color-tertiary);
  min-height: 1.25rem;
}
.time-header p {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--ion-color-light);
  margin: 0;
}

ion-header {
  background-color: var(--ion-color-tertiary);
}

.site-header {
  background-color: var(--ion-color-tertiary);
  min-height: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 550px) {
  .site-header {
    min-height: 3rem;
  }
}
.site-header .site-header-logo {
  display: flex;
  align-items: center;
}
.site-header .site-header-logo ion-menu-button {
  font-size: 1.5rem;
}
.site-header .site-header-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-right: 1rem;
}
@media (max-width: 550px) {
  .site-header .site-header-buttons .header-button {
    width: 4.5rem !important;
  }
}

@media screen and (max-width: 550px) {
  app-deposit-button::ng-deep ion-button {
    width: auto !important;
  }
  .site-header {
    justify-content: space-between;
  }
  .site-header .site-header-buttons {
    gap: 0.2rem;
    margin-right: 0.2rem;
  }
}
.navbar-right-menu-container {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 1.25rem;
  border: 2px solid var(--ion-color-secondary);
  display: flex;
  justify-content: center;
  align-items: center;
}
.navbar-right-menu-container ion-icon[name=person-outline] {
  cursor: pointer;
  font-size: 1.5rem;
  color: var(--ion-color-secondary);
}
@media (max-width: 550px) {
  .navbar-right-menu-container {
    height: 2.3rem;
    width: 2.3rem;
  }
}

.navbar-deposit-component {
  display: flex;
  max-height: 2.5rem;
}
.navbar-deposit-component .navbar-deposit-component-balance {
  display: flex;
  flex-direction: column;
  margin-right: 0.5rem;
  align-items: flex-end;
  margin-top: 0.25rem;
  margin-bottom: 2px;
  min-width: 4rem;
}
.navbar-deposit-component .navbar-deposit-component-icon {
  display: flex;
  flex-direction: column;
}

h6 {
  font-family: "roboto";
  margin: 0 !important;
  padding: 0 !important;
  color: var(--ion-color-light);
  font-weight: bold;
  font-size: 0.75rem;
}

.hidden {
  display: none !important;
}

.margin-bw-sh-buttons {
  margin-left: 3px;
}

@media (orientation: landscape) {
  .isIosWeb {
    margin-left: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/site-header/site-header.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AACR;;AAGA;EACI,2CAAA;AAAJ;;AAGA;EAEI,2CAAA;EACA,gBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFJ;AAII;EATJ;IAUQ,gBAAA;EADN;AACF;AAGI;EACI,aAAA;EACA,mBAAA;AADR;AAGQ;EACI,iBAAA;AADZ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAHR;AAMY;EADJ;IAEQ,wBAAA;EAHd;AACF;;AASA;EAEQ;IACI,sBAAA;EAPV;EAWE;IACI,8BAAA;EATN;EAWM;IACI,WAAA;IACA,oBAAA;EATV;AACF;AAeA;EAEI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAdJ;AAgBI;EACI,eAAA;EACA,iBAAA;EACA,iCAAA;AAdR;AAiBI;EAhBJ;IAiBQ,cAAA;IACA,aAAA;EAdN;AACF;;AAkBA;EACI,aAAA;EACA,kBAAA;AAfJ;AAiBI;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAfR;AAkBI;EACI,aAAA;EACA,sBAAA;AAhBR;;AAqBA;EACI,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;AAlBJ;;AAqBA;EACI,wBAAA;AAlBJ;;AAoBA;EACI,gBAAA;AAjBJ;;AAsBI;EADJ;IAEQ,iBAAA;EAlBN;AACF","sourcesContent":[".time-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: var(--ion-color-tertiary);\r\n    min-height: 1.25rem;\r\n\r\n    p {\r\n        font-size: 0.75rem;\r\n        font-weight: 700;\r\n        color: var(--ion-color-light);\r\n        margin: 0;\r\n    }\r\n}\r\n\r\nion-header {\r\n    background-color: var(--ion-color-tertiary);\r\n}\r\n\r\n.site-header {\r\n\r\n    background-color: var(--ion-color-tertiary);\r\n    min-height: 4rem;\r\n\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    @media (max-width: 550px) {\r\n        min-height: 3rem;\r\n    }\r\n\r\n    .site-header-logo {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        ion-menu-button {\r\n            font-size: 1.5rem;\r\n        }\r\n    }\r\n\r\n    .site-header-buttons {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 1rem;\r\n        margin-right: 1rem;\r\n\r\n        .header-button {\r\n            @media (max-width: 550px) {\r\n                width: 4.5rem !important;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n    app-deposit-button::ng-deep {\r\n        ion-button {\r\n            width: auto !important;\r\n        }\r\n    }\r\n\r\n    .site-header {\r\n        justify-content: space-between;\r\n\r\n        .site-header-buttons {\r\n            gap: 0.2rem;\r\n            margin-right: 0.2rem;\r\n\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.navbar-right-menu-container {\r\n\r\n    height: 2.5rem;\r\n    width: 2.5rem;\r\n    border-radius: 1.25rem;\r\n    border: 2px solid var(--ion-color-secondary);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    ion-icon[name='person-outline'] {\r\n        cursor: pointer;\r\n        font-size: 1.5rem;\r\n        color: var(--ion-color-secondary);\r\n    }\r\n\r\n    @media (max-width: 550px) {\r\n        height: 2.3rem;\r\n        width: 2.3rem;\r\n    }\r\n}\r\n\r\n\r\n.navbar-deposit-component {\r\n    display: flex;\r\n    max-height: 2.5rem;\r\n\r\n    .navbar-deposit-component-balance {\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-right: .5rem;\r\n        align-items: flex-end;\r\n        margin-top: .25rem;\r\n        margin-bottom: 2px;\r\n        min-width: 4rem;\r\n    }\r\n\r\n    .navbar-deposit-component-icon {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n}\r\n\r\nh6 {\r\n    font-family: 'roboto';\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    color: var(--ion-color-light);\r\n    font-weight: bold;\r\n    font-size: .75rem;\r\n}\r\n\r\n.hidden {\r\n    display: none !important;\r\n}\r\n.margin-bw-sh-buttons {\r\n    margin-left:3px;\r\n}\r\n\r\n// for ios web notch when rotate\r\n.isIosWeb{\r\n    @media (orientation: landscape) {\r\n        margin-left: 24px;\r\n    }\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
